import type { ArchiveEvent } from "@/features/archive/mediators/archiveEvents";
import { createMediator, type Mediator } from "@/shared/lib/componentHierarchy";

export type ArchiveItemState = {
  readonly isR18Revealed: boolean;
  readonly threadId: string;
};

export type ArchiveItemEvent = Extract<
  ArchiveEvent,
  {
    type: "archive/item-reveal-requested" | "archive/item-synchronized";
  }
>;

export function createArchiveItemMediator(
  threadId: string,
  restoredState?: ArchiveItemState,
): Mediator<ArchiveItemState, ArchiveItemEvent> {
  return createMediator<ArchiveItemState, ArchiveItemEvent>(
    {
      isR18Revealed:
        restoredState?.threadId === threadId && restoredState.isR18Revealed,
      threadId,
    },
    (state, event) => {
      switch (event.type) {
        case "archive/item-reveal-requested":
          return {
            status: "handled",
            state: { ...state, isR18Revealed: true },
          };
        case "archive/item-synchronized":
          return {
            status: "handled",
            state:
              event.threadId === state.threadId
                ? state
                : { isR18Revealed: false, threadId: event.threadId },
          };
      }
    },
  );
}
